// Last-two-labels root. Acceptable for the domains we configure (e.g. `getmobly.com`,
// `mobly-envelope.com`). Multi-part TLDs like `.co.uk` would need PSL — revisit if
// a distributor ever needs one.
const getRegistrableRoot = (host) => {
  if (!host) return '';
  const labels = host.toLowerCase().replace(/^www\./, '').split('.').filter(Boolean);
  if (labels.length < 2) return labels.join('.');
  return labels.slice(-2).join('.');
};

export const isDistributorTeamMember = ({ email, distributor }) => {
  const distributorDomain = distributor?.whiteLabel?.domain;
  if (!email || !distributorDomain) return false;

  const emailHost = email.toLowerCase().split('@')[1];
  if (!emailHost) return false;

  const distributorRoot = getRegistrableRoot(distributorDomain);
  if (!distributorRoot) return false;

  return emailHost === distributorRoot || emailHost.endsWith(`.${distributorRoot}`);
};
